import {Box} from "@mantine/core"
import {StatCard} from "./components/StatCard";
import {DashboardIcons} from "../common/constants";
import {Duration} from "dayjs/plugin/duration";
import classes from "./StatCards.module.css"
import cx from "clsx";
import {showGTZero} from "../common/utils";

export interface StatCardsProps {
    stimStepCount: number,
    totalStimTime: Duration
    megScanCount: number,
    totalMegScanDuration: Duration
    eegScanCount: number,
    totalEegScanDuration: Duration
    sessionCount: number,
    completedCount: number,
}

export const StatCards: React.FC<StatCardsProps> = ({
                                                        stimStepCount,
                                                        totalStimTime,
                                                        megScanCount,
                                                        totalMegScanDuration,
                                                        eegScanCount,
                                                        totalEegScanDuration,
                                                        sessionCount,
                                                        completedCount,
                                                    }: StatCardsProps) => {

    return (
        <Box className={cx(classes.root)}>
            <StatCard icon={<DashboardIcons.notesIcon/>}
                      stat={sessionCount}
                      statText="Sessions"
                      substat={completedCount}
                      substatText="Completed"
            />
            {showGTZero(stimStepCount,
                <StatCard icon={<DashboardIcons.stimulationsIcon/>}
                          stat={totalStimTime.asMinutes()}
                          statText="Stimulation Minutes"
                          substat={stimStepCount}
                          substatText={"Treatments"}
                />
            )}
            {showGTZero(megScanCount,
                <StatCard icon={<DashboardIcons.megScanIcon/>}
                          stat={totalMegScanDuration.asMinutes()}
                          statText={"MEG Minutes"}
                          substat={megScanCount}
                          substatText="Scans"
                />
            )}
            {showGTZero(eegScanCount,
                <StatCard icon={<DashboardIcons.eegScanIcon/>}
                          stat={totalEegScanDuration.asMinutes()}
                          statText={"EEG Minutes"}
                          substat={eegScanCount}
                          substatText="Scans"
                />
            )}
        </Box>
    )
}